<template>
	<div>
		<div
			class="preview"
			v-if="!nftList.length"
			ref="preview">
			<div
				class="huaview"
				v-for="(_, index) in 3"
				:key="index">
				<div :style="index === 1 ? 'transform: scale(1.1);' : ''">
					<Skeleton
						animate
						avatar
						avatar-shape="square" />
				</div>
			</div>
		</div>
		<swiper
			v-else
			:options="swiperOptions"
			loop
			class="phua"
			ref="mySwiper"
			@click.native="swiperClick()">
			<swiper-slide
				v-for="(item, index) in nftList"
				:key="index"
				class="huaview">
				<div>
					<img
						@click.stop
						:src="item.thumbnail"
						class="img_hyshnft"
						alt="" />
					<div class="huabot">
						<span
							class="heyue"
							@click.stop
							>{{ item.name }}</span
						>
						<span
							class="hemiao"
							@click.stop
							>{{ item.synopsis }}</span
						>
						<div class="henum">
							<span
								class="price"
								@click.stop
								>${{ item.price }}</span
							>
							<div class="gou">
								{{ $t('new.gname') }}
							</div>
						</div>
					</div>
				</div>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	import { Skeleton } from 'vant';
	export default {
		props: {
			nftList: Array,
		},
		components: {
			Skeleton,
		},
		data() {
			return {
				swiperOptions: {
					effect: 'coverflow',
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
					spaceBetween: 30,
					initialSlide: 0,
					coverflowEffect: {
						rotate: 10,
						stretch: 0,
						depth: 90,
						modifier: 1,
						slideShadows: true,
					},
					loop: true,
				},
			};
		},
		created() {
			try {
				this.$nextTick(() => {
					this.$refs?.preview?.scrollTo(152, 0);
					this.$refs?.mySwiper?.swiper.slideTo(1);
				});
			} catch (e) {}
		},
		mounted() {
			// try {
			//     this.$nextTick(() => {
			//         this.$refs?.mySwiper?.swiper.slideTo(0);
			//     });
			// } catch (e) {}
		},
		methods: {
			swiperClick() {
				const index = this.$refs.mySwiper.swiper.realIndex; //获取下标
				const { id } = this.nftList[index];
				this.$router.push({ path: '/NFTDetail?id=' + id });
			},
		},
	};
</script>

<style lang="less" scoped>
	.swiper-container {
		width: 100%;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.swiper-slide {
		box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
		position: relative;
		height: 210px;
		width: 280px !important;
	}
	.swiper-slide-active {
		transform: scale(1.1) !important;
		transition: all 0.3s ease-in-out;
	}
	.swiper-slide .lay-pop {
		display: none;
	}
	.swiper-slide-active .lay-pop {
		display: block;
	}

	@keyframes glow {
		0%,
		100% {
			opacity: 0.9;
		}
		50% {
			opacity: 1;
		}
	}

	.pfname {
		font-weight: bold;
		font-size: 14px;
		color: #1a1a1a;
		display: block;
		margin-bottom: 15px;
	}

	.phua {
		overflow: hidden;
		.huaview {
			width: 200px;
			background: #ffffff;
			border-radius: 20px;

			padding: 0 0;
			display: inline-block;

			.img_hyshnft {
				width: 100%;
				height: 110px;
				border-radius: 20px;
			}

			.huabot {
				padding: 10px 10px;
				display: flex;
				flex-direction: column;

				.heyue {
					font-weight: bold;
					font-size: 14px;
					color: #1a1a1a;
				}

				.hemiao {
					font-weight: 400;
					font-size: 10px;
					color: #999999;
					display: block;
					margin: 2px 0 2px;
					white-space: normal;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					height: 30px;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				.henum {
					display: flex;
					flex-direction: row;
					align-items: center;

					.price {
						font-weight: bold;
						font-size: 15px;
						color: #1a1a1a;
					}
				}

				.gou {
					margin-left: auto;
					width: 60px;
					height: 24px;
					background: #1a1a1a;
					border-radius: 8px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: bold;
					font-size: 13px;
					color: #ffffff;
					pointer-events: all;
				}
			}
		}
	}

	.preview {
		position: relative;
		white-space: nowrap;
		overflow-x: auto;
		height: max-content;
		overflow-y: hidden;
		.huaview {
			display: inline-block;
			padding-top: 10px;
		}
		.van-skeleton__avatar--square {
			width: 226px;
			background-color: #fbfbfb;
			padding: 0;
			height: 190px;
			border-radius: 20px;
		}
		.van-skeleton__avatar {
			margin-right: 30px !important;
		}
		.van-skeleton {
			padding: 0 !important;
		}
	}
</style>
